<div class="d-flex flex-column card-container mt-md-4 mt-0" [routerLink]="routerUrl">
    <div class="image-container d-flex justify-content-center align-items-center">
        <img [src]="facultyImage">
    </div>
    <h2 class="text-center mt-3">
            {{facultyName}}
    </h2>
</div>
